import ViaeLocation from "./Location";
import LatLng from "./LatLng";
import Series from "./Series";
import StartList from "./StartList";
import ContestFilteredContentItem from "./ContestFilteredContentItem";
import SeriesItem from "./SeriesItem";
import StartListItem from "./StartListItem";

export default class Contest {
  constructor(private readonly _id: string,
              private readonly _title: string,
              private readonly _remarks: string,
              private readonly _date: string,
              private readonly _categories: string[],
              private readonly _address: string,
              private readonly _clubName: string,
              private readonly _farrier: string,
              private readonly _veterinarian: string,
              private readonly _localResponsible: string,
              private readonly _firstAid: string,
              private readonly _mainJury: string,
              private readonly _location: {
                lat: number,
                lng: number
              },
              private readonly _series: Series) {
  }


  get id(): string {
    return this._id;
  }

  get title(): string {
    return this._title;
  }

  get date(): string {
    return this._date;
  }

  get categories(): string[] {
    return this._categories;
  }

  get address(): string {
    return this._address;
  }

  get clubName(): string {
    return this._clubName;
  }

  get farrier(): string {
    return this._farrier;
  }

  get veterinarian(): string {
    return this._veterinarian;
  }

  get localResponsible(): string {
    return this._localResponsible;
  }

  get firstAid(): string {
    return this._firstAid;
  }

  get mainJury(): string {
    return this._mainJury;
  }

  get location(): ViaeLocation {
    let address = `${this._address}`;
    return new ViaeLocation("1", address, new LatLng(this._location.lng, this._location.lat));
  }

  get remarks(): string {
    return this._remarks;
  }

  hasLocation() {
    return this._location && this._location.lat !== -1 && this._location.lng !== -1;
  }

  get series(): Series {
    return this._series;
  }

  getStartList(seriesId: string) {
    let series = this.series.filter(s => s.id === seriesId).get(0);
    return series.startList ? series.startList : new StartList();
  }

  filterContent(searchValue: string): ContestFilteredContentItem[] {
    if (!searchValue || searchValue.length < 3) {
      return [];
    }
    const result: ContestFilteredContentItem[] = [];
    this.series.forEach((seriesItem: SeriesItem, index: number) => {
      const filteredStartList = seriesItem.startList
        .filterContent(searchValue);
      filteredStartList.forEach((startListItem: StartListItem, index: number) => {
        result.push(new ContestFilteredContentItem(
          startListItem.startHour,
          startListItem.startMinutes,
          seriesItem.type,
          seriesItem.arena,
          seriesItem.difficulty,
          startListItem.startNumber,
          startListItem.headNumber,
          startListItem.rider,
          startListItem.horse,
          startListItem.clubName
        ))
      });
    });
    return result.sort((a, b) => this.compareStartListItems(a, b));
  }

  private compareStartListItems(a: ContestFilteredContentItem, b: ContestFilteredContentItem): number {
    let aValue = a.startHour + ":" + a.startMinutes;
    let bValue = b.startHour + ":" + b.startMinutes;
    let result = 0;
    if (aValue < bValue) {
      result = -1;
    } else if (aValue > bValue) {
      result = 1;
    }
    return result
  }
}
